import { Auth0Provider } from "@auth0/auth0-react";
import { FilePreviewDialog } from "components/filePreview/FilePreviewDialog";
import InstallPWA from "components/InstallPWA";
import ConnectionStatusProvider from "context/ConnectionStatus";
import ConsentProvider from "context/ConsentProvider";
import { MenuAppBar } from "pages/appBar/MenuAppBar";
import { LocationSettingsDialog } from "pages/dialogs/LocationSettingsDialog";
import { QueueDialog } from "pages/dialogs/QueueDialog";
import { ComponentType, FC } from "react";
import { useAppSelector } from "store";
import { selectAuth0 } from "store/slices/user.store";
import AuthGuard from "./AuthGuard";
import { AutoSyncDocumentsSettingsDialog } from "./dialogs/AutoSyncDocumentsSettingsDialog";
import { UserTrackingSettingsDialog } from "./dialogs/UserTrackingSettingsDialog";

interface PrivateRouteProps {
  component: ComponentType<any>;
}

export const PrivateRoute: FC<PrivateRouteProps> = ({ component: Component }) => {
  const { domain, clientId, audience } = useAppSelector(selectAuth0);

  return (
    <Auth0Provider
      domain={domain!}
      clientId={clientId!}
      redirectUri={`${window.location.origin}/login/auth0callback/`}
      audience={audience!}
      scope="read:current_user update:current_user_metadata"
      useRefreshTokens
      cacheLocation="localstorage"
    >
      <AuthGuard>
        <ConsentProvider>
          <ConnectionStatusProvider>
            <MenuAppBar />
            <InstallPWA />
            <Component />
            <QueueDialog />
            <LocationSettingsDialog />
            <UserTrackingSettingsDialog />
            <AutoSyncDocumentsSettingsDialog />
            <FilePreviewDialog />
          </ConnectionStatusProvider>
        </ConsentProvider>
      </AuthGuard>
    </Auth0Provider>
  );
};
